import React, { useEffect } from "react";
import { Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { isIE } from "react-device-detect";
import { useUserSettings } from "./useUserSettings";
import messages from "./messages";
import { useDialogStyles, useStyles } from "./styles";
import { FormattedMessage } from "react-intl";
import { UserActions } from "../UserActions";
import { PasswordField } from "../../../../shared";
import { RequestStatus, userService } from "../../shared";
import { useHookSubscribe } from "../../../react-rxjs";

export const UserSettings: React.FC = (props) => {
  const classes = useStyles(props);
  const dialogClasses = useDialogStyles(props);
  const user = useHookSubscribe(null, userService.user$);
  const [openMigrationDialog, setOpenMigrationDialog] = React.useState(false);
  const closeMigrationDialog = React.useCallback(() => setOpenMigrationDialog(false), []);
  React.useEffect(() => {
    if (user?.migrationPasswordValid === false) {
      setOpenMigrationDialog(true);
    }
  }, [user]);

  const { apply, validPass, validNewPass, state, resetUserSettings, setValidPass, setValidNewPass, changeField, status } =
    useUserSettings();

  const renderSuccessMessage = () => {
    return (
      <Typography color="primary">
        <FormattedMessage {...messages.success} />
      </Typography>
    );
  };
  useEffect(() => {
    if (status === RequestStatus.Fail) {
      resetUserSettings();
    }
  }, [status]);
  const onCancelClick = () => {
    state.password = "";
    resetUserSettings();
  };
  return (
    <>
      <Dialog
        open={openMigrationDialog}
        onClose={closeMigrationDialog}
        classes={{ paper: dialogClasses.root }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className={dialogClasses.header}>
          {""}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className={dialogClasses.text}>
            We switch AgTerminal to the new platform and apply new design.
            <br />
            As we are in a new platform, you will be asked to change your password.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeMigrationDialog} variant="contained" color="primary" autoFocus classes={classes}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.fieldItem}>
        <PasswordField
          InputLabelProps={{
            className: classes.fieldName,
            shrink: isIE ? true : undefined,
          }}
          variant="outlined"
          disabled={user?.migrationPasswordValid === false}
          className={classes.fieldContent}
          value={user?.migrationPasswordValid === false ? "password" : state.password}
          onChange={({ target }) => changeField("password", target.value)}
          onPasswordInvalid={() => setValidPass(false)}
          onPasswordValid={() => setValidPass(true)}
          useMatch={false}
          customErrorState={status === RequestStatus.Fail && !state.password ? true : false}
          customHelperText={
            status === RequestStatus.Fail && !state.password ? <FormattedMessage {...messages.passwordWrongError} /> : undefined
          }
        />
      </div>
      <div className={classes.fieldItem}>
        <PasswordField
          InputLabelProps={{
            className: classes.fieldName,
            shrink: isIE ? true : undefined,
          }}
          variant="outlined"
          className={classes.fieldContent}
          value={state.newPassword}
          onChange={({ target }) => changeField("newPassword", target.value)}
          mode="newPassword"
          confirmPassword={state.confirmPassword}
          customErrorState={status === RequestStatus.Fail && !state.newPassword ? false : undefined}
          useMatch
        />
      </div>
      <div className={classes.fieldItem}>
        <PasswordField
          InputLabelProps={{
            className: classes.fieldName,
            shrink: isIE ? true : undefined,
          }}
          variant="outlined"
          className={classes.fieldContent}
          value={state.confirmPassword}
          onChange={({ target }) => changeField("confirmPassword", target.value)}
          onPasswordInvalid={() => setValidNewPass(false)}
          onPasswordValid={() => setValidNewPass(true)}
          mode="confirmPassword"
          newPassword={state.newPassword}
          customErrorState={status === RequestStatus.Fail && !state.confirmPassword ? false : undefined}
          useMatch
        />
      </div>
      <UserActions onApply={apply} onCancel={onCancelClick} valid={state.newPassword !== state.password && validNewPass && validPass} />
      {status === RequestStatus.Success && renderSuccessMessage()}
    </>
  );
};
